import {
  FETCH_PROFITLOSS_REQUEST,
  FETCH_PROFITLOSS_SUCCESS,
  FETCH_PROFITLOSS_FAILURE,
} from "./profitlossActionTypes";

const initialState = {
  loading: false,
  profitLossData: null,
  error: "",
};

const profitlossReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFITLOSS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PROFITLOSS_SUCCESS:
      return {
        ...state,
        loading: false,
        profitLossData: action.payload.data,
        error: "",
      };
    case FETCH_PROFITLOSS_FAILURE:
      return {
        ...state,
        loading: false,
        profitLossData: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default profitlossReducer;